<template>
  <b-table show-empty striped hover class="aco-table"
           :empty-text="$t('noResults')"
           :items="subscriptions" :fields="subscriptionFields">
    <template v-slot:cell(show_details)="row">
      <b-button-group style="width: 250px">
        <b-button type="submit" variant="primary" v-b-modal="`confirm-restart-${row.item.uuid}`">Restart</b-button>
        <b-button type="submit" variant="warning" v-b-modal="`confirm-cancel-${row.item.uuid}`" v-if="row.item.renewAt">Kanseller</b-button>
        <b-button type="submit" variant="danger" v-b-modal="`confirm-delete-${row.item.uuid}`" v-if="row.item.renewAt">Slett</b-button>
      </b-button-group>
      <b-modal :id="`confirm-restart-${row.item.uuid}`" no-stacking>
        <template slot="modal-title">Restart</template>
        <p>Bekreft restart av abonnement.</p>
        <template slot="modal-footer">
          <b-button variant="primary" v-on:click="restartSubscription(row.item)" :disabled="isLoading">
            Restart
          </b-button>
          <b-button variant="secondary" class="float-lg-right" @click="$bvModal.hide(`confirm-restart-${row.item.uuid}`)" :disabled="isLoading">
            {{ $t('cancel') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal :id="`confirm-cancel-${row.item.uuid}`" no-stacking>
        <template slot="modal-title">Kanseller</template>
        <p>Bekreft kansellering av abonnement.</p>
        <template slot="modal-footer">
          <b-button variant="primary" v-on:click="cancelSubscription(row.item)" :disabled="isLoading">
            Bekreft
          </b-button>
          <b-button variant="secondary" class="float-lg-right" @click="$bvModal.hide(`confirm-cancel-${row.item.uuid}`)" :disabled="isLoading">
            {{ $t('cancel') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal :id="`confirm-delete-${row.item.uuid}`" no-stacking>
        <template slot="modal-title">Slett</template>
        <p class="my-0">Bekreft sletting av abonnement</p>
        <template slot="modal-footer">
          <b-button-group>
            <b-button variant="danger" v-on:click="deleteSubscription(row.item)" :disabled="isLoading">
              Slett
            </b-button>
            <b-button variant="secondary" @click="$bvModal.hide(`confirm-delete-${row.item.uuid}`)" :disabled="isLoading">
              {{ $t('cancel') }}
            </b-button>
          </b-button-group>
        </template>
      </b-modal>
    </template>
  </b-table>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SubscriptionList',
    extends: BaseComponent,


    data: () => ({
      isLoading: false,
    }),
    created: function () {
      this.$store.dispatch('subscriptions/getSubscriptions')
    },
    computed: {
      ...mapGetters('subscriptions', ['subscriptions']),
      subscriptionFields () {
        return [
          { key: 'buyerId', label: this.$t('subscription.buyerId') },
          { key: 'buyerName', label: this.$t('subscription.buyerName') },
          { key: 'ownerId', label: this.$t('subscription.ownerId') },
          { key: 'ownerName', label: this.$t('subscription.ownerName') },
          { key: 'productId', label: this.$t('subscription.productId') },
          { key: 'productName', label: this.$t('subscription.productName') },
          { key: 'quantity', label: this.$t('subscription.quantity') },
          { key: 'subscriptionContractId', label: this.$t('subscription.subscriptionContractId') },
          { key: 'initialPrice', label: this.$t('subscription.initialPrice'), formatter: (value) => value/100 },
          { key: 'recurringPrice', label: this.$t('subscription.recurringPrice'), formatter: (value) => value/100 },
          { key: 'startAt', label: this.$t('subscription.startAt'), formatter: (value) => new Date(value).toLocaleDateString('nor-NO') },
          { key: 'renewAt', label: this.$t('subscription.renewAt'), formatter: (value) => value ? new Date(value).toLocaleDateString('nor-NO') : '' },
          { key: 'createdAt', label: this.$t('subscription.createdAt'), formatter: (value) => new Date(value).toLocaleString('nor-NO') },
          { key: 'updatedAt', label: this.$t('subscription.updatedAt'), formatter: (value) => new Date(value).toLocaleString('nor-NO') },
          { key: 'show_details', label: '' }
        ]
      }
    },
    methods: {
      async restartSubscription(subscription) {
        try {
          this.isLoading = true
          await this.$store.dispatch('subscriptions/postSubscription', subscription.uuid)
          await this.$store.dispatch('subscriptions/getSubscriptions')
          this.$bvToast.toast('Abonnementet ble restartet', {
            title: 'Abonnement',
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 2000
          });
        } catch (error) {
          this.$bvToast.toast('Noe gikk galt', {
            title: 'Abonnement',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 2000
          });
          throw error
        } finally {
          this.isLoading = false
          this.$bvModal.hide(`confirm-restart-${subscription.uuid}`)
        }
      },

      async cancelSubscription(subscription) {
        try {
          this.isLoading = true
          await this.$store.dispatch('subscriptions/cancelSubscription', subscription.uuid)
          await this.$store.dispatch('subscriptions/getSubscriptions')
          this.$bvToast.toast('Abonnementet ble kansellert', {
            title: 'Abonnement',
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 2000
          });
        } catch (error) {
          this.$bvToast.toast('Noe gikk galt', {
            title: 'Abonnement',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 2000
          });
          throw error
        } finally {
          this.isLoading = false
          this.$bvModal.hide(`confirm-cancel-${subscription.uuid}`)
        }
      },

      async deleteSubscription(subscription) {
        try {
          this.isLoading = true
          await this.$store.dispatch('subscriptions/deleteSubscription', subscription.uuid)
          await this.$store.dispatch('subscriptions/getSubscriptions')
          this.$bvToast.toast('Abonnementet ble slettet', {
            title: 'Abonnement',
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 2000
          });
        } catch (error) {
          this.$bvToast.toast('Noe gikk galt', {
            title: 'Abonnement',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 2000
          });
          throw error
        } finally {
          this.isLoading = false
          this.$bvModal.hide(`confirm-delete-${subscription.uuid}`)
        }
      }
    }
  }
</script>
